module.exports = __webpack_public_path__ + "static/spotify-badge-6b82677b55a1d5a6997a3cda819ec36f.svg";